import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const CREDIT_NOTE_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<CreditNote>[] = [
    { name: "credit_note_type_label", label: "Type" },
    { name: "total", label: "Total" },
    { name: "date_issued", label: "Issued" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const CREDIT_NOTE_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<CreditNote>[] = [
    { name: "id", label: "ID" },
    { name: "client_name", label: "Client" },
    { name: "status_label", label: "Status" },
    { name: "credit_note_type_label", label: "Type" },
    { name: "total", label: "Total" },
    { name: "date_issued", label: "Issued" },
    { name: "last_modified_at", label: "Last Modified" },
]
